import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaBullseye, 
  FaEye, 
  FaGem, 
  FaIndustry, 
  FaMicroscope, 
  FaTint, 
  FaBoxOpen, 
  FaUserTie, 
  FaHardHat, 
  FaPhoneAlt, 
  FaTruck 
} from 'react-icons/fa';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      {/* Page Hero */}
      <section className="about-hero">
        <div className="hero-bg">
          <img src="/About Page images/office-interior.jpg" alt="About Shikhar Dhara" />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <div className="about-hero-content">
            <span className="hero-badge">About Us</span>
            <h1>About Shikhar Dhara</h1>
            <p>Your trusted partner for pure drinking water and fresh fruit beverages</p>
            <div className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <span>About Us</span>
            </div>
          </div>
        </div>
      </section>

      {/* Company Story */}
      <section className="company-story section">
        <div className="container">
          <div className="story-grid">
            <div className="story-content">
              <span className="section-label">Our Story</span>
              <h2>A Journey of Purity & Excellence</h2>
              <p>
                Shikhar Dhara was founded with a simple yet powerful vision – to provide 
                every household and business with access to pure, safe drinking water and 
                refreshing beverages that meet the highest quality standards.
              </p>
              <p>
                Based in the industrial hub of Bareilly, Uttar Pradesh, our state-of-the-art 
                manufacturing facility combines advanced technology with stringent quality 
                control to deliver products that you can trust.
              </p>
              <p>
                What started as a small venture has grown into a leading manufacturer of 
                packaged drinking water and litchi fruit juice, serving thousands of 
                satisfied customers across the region.
              </p>
            </div>
            <div className="story-image">
              <img src="../About Page images/manufacturing-facility.jpg" alt="Shikhar Dhara Manufacturing Facility" />
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="mission-vision section bg-light">
        <div className="container">
          <div className="mv-grid">
            <div className="mv-card mission">
              <div className="mv-icon"><FaBullseye /></div>
              <h3>Our Mission</h3>
              <p>
                To deliver premium quality packaged drinking water and beverages that 
                exceed customer expectations while maintaining the highest standards of 
                hygiene, purity, and sustainability.
              </p>
            </div>
            <div className="mv-card vision">
              <div className="mv-icon"><FaEye /></div>
              <h3>Our Vision</h3>
              <p>
                To become the most trusted name in packaged beverages across North India, 
                known for our unwavering commitment to quality, innovation, and customer 
                satisfaction.
              </p>
            </div>
            <div className="mv-card values">
              <div className="mv-icon"><FaGem /></div>
              <h3>Our Values</h3>
              <ul>
                <li>Purity in every drop</li>
                <li>Quality without compromise</li>
                <li>Customer satisfaction first</li>
                <li>Sustainable practices</li>
                <li>Continuous innovation</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Company Stats */}
      <section className="company-stats section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <span className="stat-number">2+</span>
              <span className="stat-label">Years Experience</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">200+</span>
              <span className="stat-label">Distribution Partners</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">1M+</span>
              <span className="stat-label">Bottles Delivered</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">100%</span>
              <span className="stat-label">Quality Certified</span>
            </div>
          </div>
        </div>
      </section>

      {/* Manufacturing Facility */}
      <section className="facility-section section bg-light">
        <div className="container">
          <div className="section-header">
            <h2>Our Manufacturing Facility</h2>
            <p>State-of-the-art production with international quality standards</p>
          </div>
          
          <div className="facility-grid">
            <div className="facility-image-main">
              <img src="/About Page images/manufacturing-facility.jpg" alt="Main Manufacturing Facility" />
            </div>
            <div className="facility-features">
              <div className="facility-feature">
                <div className="feature-icon"><FaIndustry /></div>
                <div>
                  <h4>Modern Production Lines</h4>
                  <p>Fully automated bottling with minimal human contact for maximum hygiene</p>
                </div>
              </div>
              <div className="facility-feature">
                <div className="feature-icon"><FaMicroscope /></div>
                <div>
                  <h4>In-house Quality Lab</h4>
                  <p>Every batch tested for purity, TDS, pH levels, and microbiological safety</p>
                </div>
              </div>
              <div className="facility-feature">
                <div className="feature-icon"><FaTint /></div>
                <div>
                  <h4>Advanced Purification</h4>
                  <p>Multi-stage RO, UV treatment, and ozonization for crystal clear water</p>
                </div>
              </div>
              <div className="facility-feature">
                <div className="feature-icon"><FaBoxOpen /></div>
                <div>
                  <h4>Hygienic Packaging</h4>
                  <p>Cleanroom packaging environment with strict contamination control</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Office & Team */}
      <section className="team-section section">
        <div className="container">
          <div className="team-grid">
            <div className="team-image">
              <img src="/About Page images/office-interior.jpg" alt="Shikhar Dhara Office" />
            </div>
            <div className="team-content">
              <span className="section-label">Our Team</span>
              <h2>Dedicated Professionals</h2>
              <p>
                Behind every bottle of Shikhar Dhara is a team of dedicated professionals 
                committed to excellence. From our production floor to customer service, 
                every team member shares our passion for quality.
              </p>
              <div className="team-features">
                <div className="team-feature">
                  <span><FaUserTie /></span>
                  <span>Expert Quality Technicians</span>
                </div>
                <div className="team-feature">
                  <span><FaHardHat /></span>
                  <span>Skilled Production Staff</span>
                </div>
                <div className="team-feature">
                  <span><FaPhoneAlt /></span>
                  <span>Responsive Customer Support</span>
                </div>
                <div className="team-feature">
                  <span><FaTruck /></span>
                  <span>Efficient Logistics Team</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="about-certifications section bg-light">
        <div className="container">
          <div className="section-header">
            <h2>Our Certifications</h2>
            <p>Quality and safety certified by leading authorities</p>
          </div>
          
          <div className="cert-grid">
            <div className="cert-item">
              <img src="/logo & badge images/fssai-badge.png" alt="FSSAI" />
              <h4>FSSAI Certified</h4>
              <p>Food Safety and Standards Authority of India approved for safe consumption</p>
            </div>
            <div className="cert-item">
              <img src="/logo & badge images/iso-badge.png" alt="ISO" />
              <h4>ISO 22000:2018</h4>
              <p>International food safety management system certification</p>
            </div>
            <div className="cert-item">
              <img src="/Home Page images/bis-badge.png" alt="BIS" />
              <h4>BIS IS 14543</h4>
              <p>Bureau of Indian Standards certified for packaged drinking water</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta section">
        <div className="container">
          <div className="about-cta-content">
            <h2>Want to Know More?</h2>
            <p>Get in touch with us or visit our manufacturing facility</p>
            <div className="about-cta-buttons">
              <Link to="/contact" className="btn btn-primary">
                Contact Us
              </Link>
              <Link to="/manufacturing" className="btn btn-secondary">
                View Manufacturing
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
